import { createRouter } from "@tanstack/react-router";
import * as TanStackQueryProvider from "@/lib/tanstack-query/root-provider";
import { routeTree } from "@/routeTree.gen";
import { NotFoundErrorPage, RouteErrorFallback } from "@/lib/error-boundary";

export const router = createRouter({
	routeTree,
	context: {
		...TanStackQueryProvider.getContext(),
		auth: undefined!,
	},
	defaultPreload: "intent",
	scrollRestoration: true,
	defaultStructuralSharing: true,
	defaultPreloadStaleTime: 0,
	defaultErrorComponent: RouteErrorFallback,
	defaultNotFoundComponent: NotFoundErrorPage,
});

// Register the router instance for type safety
declare module "@tanstack/react-router" {
	interface Register {
		router: typeof router;
	}
}
